<template>
  <div class="col-12 py-1 px-0">
    <load v-if="loading" mode="table" />

    <div
      v-for="historico in historicos"
      :key="historico.id"
      class="card card-body mb-2 bg-white border-4 border-bottom border-primary"
    >
      <div class="row py-2">
        <div class="col-md-3 col-sm-12">
          <b>Evento:</b> {{ historico.event }}
        </div>
        <div class="col-md-3 col-sm-12">
          <b>Aba:</b> {{ getAbaNome(historico.auditable_type) }}
        </div>
        <div class="col-md-3 col-sm-12">
          <b>Atualizado em:</b> {{ formatDate(historico.updated_at) }}
        </div>
        <div class="col-md-3 col-sm-12">
          <b>Técnico:</b> {{ historico.tecnico?.nome || "N/A" }}
          <br />
          <small v-if="historico.tecnico?.unidade">
            Unidade: {{ historico.tecnico.unidade.nome }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      loading: false,
      historicos: [],
    };
  },
  mounted() {
    this.getHistorico();
  },
  methods: {
    getHistorico() {
      this.loading = true;
      axios
        .get("api/dashboard/acolhimento/idoso/historico/audit/" + this.id)
        .then((response) => {
          console.log("Dados de auditoria:", response.data.historicos);
          this.historicos = response.data.historicos;
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            html: `Os dados de auditoria não foram carregados corretamente<br>${error}`,
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getAbaNome(type) {
      if (!type) return "N/A";
      const nomeClasse = type.split("\\").pop();

      const map = {
        AcolhimentoIdoso: "Detalhes do Acolhimento",
        AcolhimentoIdoAspectoGeral: "Aspectos Gerais",
        AcolhimentoIdoCaractSaude: "Saúde e Desenvolvimento",
        AcolhimentoIdoEducacao: "Educação",
        AcolhimentoMetaIdoso: "Objetivos e Metas",
        AcolhimentoTermoIdo: "Termo de Compromisso",
        AcolhimentoIdoPessoaReferencia: "Pessoa de Referencia",
        AcolhimentoIdoAtividade: "Atividade",
        AcolhimentoIdoPrimObservacao: "Primeira Observacao",
        AcolhimentoIdoRemuneracao: "Trabalho e Renda",
      };

      return map[nomeClasse] || nomeClasse;
    },

    formatDate(dateString) {
      if (!dateString) return "N/A";
      // Caso use moment.js, adapte aqui:
      return this.$moment
        ? this.$moment(dateString).format("DD/MM/YYYY HH:mm")
        : new Date(dateString).toLocaleString();
    },
  },
};
</script>

<style scoped>
.card {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.border-bottom {
  border-bottom-width: 2px !important;
}
</style>
